import React from 'react';
import { createChatBotMessage } from 'react-chatbot-kit';
import IWidget from 'react-chatbot-kit/build/src/interfaces/IWidget';
import AvannisResponseMessage from './customMesagges/avannisResponseMessage';
import ChatbotLoader from './widgets/ChatbotLoader';


const config = {
    initialMessages: [createChatBotMessage(`I'm ready to help you analyze survey comments! First, use the filters at the top (date, hierarchy, survey) to select the comments you would like to focus on. Then, ask me anything—like the most common themes, the strongest feelings expressed, or any other insights you're curious about.`, undefined)],
    customStyles: {
        botMessageBox: {
            backgroundColor: 'var(--brand-blue)',
        },
        chatButton: {
            backgroundColor: 'var(--brand-blue)',
        },
    },
    customMessages: {
        avannisMessage: (props) => <AvannisResponseMessage {...props} />,
    },
    widgets: [
        {
            widgetName: 'chatbotLoader',
            widgetFunc: (props) => <ChatbotLoader {...props} />,
        },
    ] as IWidget[],
    customComponents: {
        botAvatar: () => <img src="/images/avanis-icon.png?v=2" alt="Avannis" style={{ width: "40px", height: "40px", borderRadius: "50%" }} />,
    },
};

export default config;
